<template>
    <section class="">
        <div class="hero">
            <!--<img class="" src="@/assets/banners/web_stxt.svg"  alt="Hero">
            <img class="" style="" src="@/assets/banners/heroo.png"  alt="Hero"> -->

        <picture>
            <source media="(max-width: 900px)" srcset="@/assets/banners/heroomovil.png">
            <img src="@/assets/banners/heroo.png" alt="Hero">
        </picture>

        <a href="/SephoraSale" class="btn-glow"> ✧ EXPLORAR ✧ </a>

        </div>
    </section>

</template>

<script>


</script>


<style>
    .hero {
        position: relative;
        width: 100%;
        height: 100dvh;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .hero img {
        position:absolute;
        width: 100%;
        height: auto;
        object-fit: cover;
    }

    .btn-glow {
        position: absolute;
        font-family: "Magistral_Bold";
        z-index: 10;
        display: inline-block;
        bottom: clamp(16px, 5vw, 75px);/* posición responsiva */
        left: 50%;
        transform: translateX(-50%);
        padding: clamp(10px, 2vw, 16px) clamp(20px, 4vw, 32px);/* tamaño responsivo */
        font-size: clamp(13px, 2.5vw, 19px);
        color: #ffffff;
        text-decoration: wavy;
        border-radius: 999px;
        overflow: hidden;
        backdrop-filter: blur(8px);
        background: rgba(6, 93, 255, 0.704);
    }

    .btn-glow:hover {
        animation: glowPulse 1.5s infinite alternate;/* pulso */    
    }

    @keyframes glowPulse {
        from {
            box-shadow: 0 0 5px #c4b5fd;
        }
        to {
            box-shadow: 0 0 20px #c4b5fd;
        }
    }


    /* Celulares 
@media (max-width: 768px) {
    .hero {
        height: 100vh;
    }

    .hero img {
        width: auto;
        height: 100%;
        object-fit: cover;
    }

    .btn-glow {
        bottom: clamp(16px, 3vw, 70px);/* posición responsiva 

    }
}*/

.hero picture,
.hero img {
    width: 100%;
    height: 100%;
}

.hero img {
    object-fit: cover;
}

</style>